import Vue from 'vue'
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex'
import localforage from 'localforage'
import { values } from 'lodash'
import uuid from 'uuid/v4'
import firebase from '@/firebase'
import { Circuit, CircuitState, StoreState } from '@/interfaces'
import { updateVueObject } from '@/utils'

Vue.use(Vuex)

const primaryKey: string = 'id'
let database: any

function initialState (): CircuitState {
  return {
    base: {}
  }
}

const actions: ActionTree<CircuitState, StoreState> = {
  async initialize ({ dispatch }) {
    database = firebase.firestore().collection('circuits')

    try {
      await dispatch('fetchBase')
    } catch (error) {
      throw error
    }
  },
  async fetchBase ({ commit }, offset: number = 0) {
    try {
      const snapshot = await database.where('updated', '>=', offset).get()
      const docs: Circuit[] = []

      for (const doc of snapshot.docs) {
        const data: Circuit = doc.data()

        data.id = doc.id

        docs.push(data)
      }

      await commit('setBase', docs)

      return docs
    } catch (error) {
      throw error
    }
  },
  async removeBase ({ commit, state }, circuit: Circuit) {
    try {
      await database.doc(circuit.id).delete()

      commit('removeBase', circuit)

      await localforage.setItem('circuits:base', values(state.base))
    } catch (error) {
      throw error
    }
  },
  async saveBase ({ commit, state }, circuit: Circuit) {
    try {
      if (!circuit.id) {
        circuit.created = Date.now()
      }

      circuit.id = circuit.id || uuid()
      circuit.updated = Date.now()

      await database.doc(circuit.id).set(circuit)

      commit('setBase', circuit)

      await localforage.setItem('circuits:base', values(state.base))

      return circuit
    } catch (error) {
      console.log(error)

      throw error
    }
  }
}

const getters: GetterTree<CircuitState, StoreState> = {
  all (state) {
    return state.base
  }
}

const mutations: MutationTree<CircuitState> = {
  removeBase (state, circuit: Circuit) {
    Vue.delete(state.base, circuit.id)
  },
  setBase (state, circuits: Circuit|Circuit[]) {
    updateVueObject(state.base, circuits, primaryKey)
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  getters,
  mutations
}
